export default __webpack_public_path__ + "static/media/adjustStocksFurniture.b4a31657.png";